<template>
    <div>
        <div class="actions-menu" style="display: flex; flex-wrap: wrap">
            <button class="actions-menu-item" @click="action('delivery')" v-if="$store.state.user.role.permissions.includes('can_do_deliveries')" v-tooltip.right="'Record new stock delivery from a supplier'">
                New Delivery
            </button>
            <button class="actions-menu-item" @click="action('send', 'Send')" v-tooltip.right="'Transfer Stock between drug registers and locations'">
                Stock Transfer
            </button>
            <button class="actions-menu-item" @click="action('requisition', 'Create')" v-if="$store.state.user.role.permissions.includes('can_view_transfers') && $store.state.user.requisitions_active" v-tooltip.right="'Create a new Requisition request'">
                Create Requisition
            </button>
            <button class="actions-menu-item" @click="action('bag-checkin')" v-if="$store.state.user.type == 'clinician' && $store.state.company && $store.state.company.type == 'ambulance'" v-tooltip.right="'Register a drug bag check-in'">
                Register Bag Check In
            </button>
            <button class="actions-menu-item" @click="action('bag-checkout')" v-if="$store.state.user.type == 'clinician' && $store.state.company && $store.state.company.type == 'ambulance'" v-tooltip.right="'Register a drug bag check-out'">
                Register Bag Check Out
            </button>
            <button class="actions-menu-item" @click="action('ambulance-administration')" v-if="$store.state.user.type == 'clinician' && $store.state.company && $store.state.company.type == 'ambulance'" v-tooltip.right="'Record medication administrations to patients'">
                Patient Administrations
            </button>
            <button v-if="cartonCloudRestriction || $store.state.company.type == 'aged care'" class="actions-menu-item" @click="action('destroy')" v-tooltip.right="'Record disposal or destruction of stock'">
               {{ $store.state.company.type == 'warehouse' ?  'New Destruction' : 'Dispose' }}
            </button>
            <button v-if="cartonCloudRestriction || $store.state.company.type == 'aged care'" class="actions-menu-item" @click="action('reverse')" v-tooltip.right="'Record outgoing stock movements'">
                Outgoing
            </button>
            <button class="actions-menu-item" @click="action('adjustment')" v-tooltip.right="'Perform stocktake adjustments to correct balances'">
                Adjustment
            </button>
            <button class="actions-menu-item" @click="action('administration')" v-if="$store.state.user.ecdr_active && !$store.state.user.patient_admin_active && $store.state.company.type != 'ambulance'" v-tooltip.right="'Record medication administration'">
                Administration
            </button>
            <button class="actions-menu-item" @click="action('theatre-checkout')" v-if="$store.state.user.ecdr_active && $store.state.user.role.permissions.includes('can_view_transfers') && $store.state.company.type == 'hospital'" v-tooltip.right="'Check out medications for theatre use'">
                Theatre Checkout
            </button>
            <button class="actions-menu-item" @click="action('theatre-checkin')" v-if="$store.state.user.ecdr_active && $store.state.user.role.permissions.includes('can_view_transfers') && $store.state.company.type == 'hospital'" v-tooltip.right="'Check in medications from theatre'">
                Theatre Check In
            </button>
            <button class="actions-menu-item" @click="action('receive-pom')" v-if="($store.state.company.type == 'hospital' || $store.state.company.type == 'aged care') && $store.state.user.patient_own_bags_active" v-tooltip.right="'Record check-in of patient owned medications for safekeeping'">
                Patient Own Check In
            </button>
            <button class="actions-menu-item" @click="action('clinician-hold-checkout')" v-if="$store.state.user.ecdr_active && $store.state.user.role.permissions.includes('can_view_transfers') && $store.state.user.type == 'clinician' && $store.state.company && $store.state.company.type == 'ambulance'" v-tooltip.right="'Check out drug bag for clinician use'">
                Clinician Bag Check Out
            </button>
            <button class="actions-menu-item" @click="action('clinician-hold-checkin')" v-if="$store.state.user.ecdr_active && $store.state.user.role.permissions.includes('can_view_transfers') && $store.state.user.type == 'clinician' && $store.state.company && $store.state.company.type == 'ambulance'" v-tooltip.right="'Check in drug bag from clinician use'">
                Clinician Bag Check In
            </button>
            <button class="actions-menu-item" @click="action('order')" v-if="cartonCloudRestriction" v-tooltip.right="'Create a new purchase or sales order'">
                New Order
            </button>
            <!-- <button class="actions-menu-item" @click="action('return')" v-if="$store.state.company.type == 'warehouse'">
                Returns
            </button> -->
            <button class="actions-menu-item" @click="action('batch')" v-if="$store.state.company.type == 'warehouse'" v-tooltip.right="'Create a new inventory batch'">
                New Batch
            </button>
            <button class="actions-menu-item" @click="action('receive', 'Receive')" v-tooltip.right="'Transfer Stock In from Locations Outside your Organisation'">
                Inbound Transfer
            </button>
        </div>
        <!-- <Destroy v-show="displayForm=='destroy'" />
        <Move v-show="displayForm=='move'" />
        <Receive v-show="displayForm=='receive'" />
        <Reverse v-show="displayForm=='reverse'" /> -->
        <NewTransferModal v-if="(displayForm == 'send') || (displayForm == 'receive')" @close="close" :transferType="transferType" />
        <DestructionModal v-if="displayForm == 'destroy'" @close="close" :transferType="transferType" />
        <LostDamagedModal v-if="displayForm == 'reverse'" @close="close" :transferType="transferType" />
        <AdjustmentModal v-if="displayForm == 'adjustment'" @close="close" :transferType="transferType" />
        <AdministrationModal v-if="displayForm == 'administration'" @close="close" :transferType="transferType" />
        <TheatreCheckoutModal v-if="displayForm == 'theatre-checkout'" @close="close" />
        <TheatreCheckinModal v-if="displayForm == 'theatre-checkin'" @close="close" />
        <ClinicianHoldCheckoutModal v-if="displayForm == 'clinician-hold-checkout'" @close="close" />
        <ClinicianHoldCheckinModal v-if="displayForm == 'clinician-hold-checkin'" @close="close" />
        <BagCheckinModal v-if="displayForm == 'bag-checkin'" @close="close" @isSuccessful="isSuccessful" />
        <BagCheckoutModal v-if="displayForm == 'bag-checkout'" @close="close" @isSuccessful="isSuccessful" />
        <ReceivePOMModal v-if="displayForm == 'receive-pom'" @close="close" />
        <AmbulanceAdministrationModal v-if="displayForm == 'ambulance-administration'" @close="close" @isSuccessful="isSuccessful"
            :checkinUuid="administrationContext ? administrationContext.checkinUuid : null"
            :presetMissionNumber="administrationContext ? administrationContext.missionNumber : null" />
        <DeliveryModal v-if="displayForm == 'delivery'" @close="close" transferType="Deliveries" buttonName="New Deliveries"/>
        <DeliveryModal v-if="displayForm == 'order'" @close="close" transferType="Deliveries" 
        buttonName="New Orders"  />
        <DeliveryModal v-if="displayForm == 'return'"  @close="close" transferType="Deliveries" buttonName="New Returns"  />
        <BatchModal v-if="displayForm == 'batch'" @close="close"/>
        <NewRequisitionModal v-if="displayForm == 'requisition'" @close="close" :mode="transferType" />
        <ConfirmationModal v-if="displayConfirmModal" :actionDescription="'It looks like you are trying to check drugs from a bag into a bag. Are you sure?'" @close="displayConfirmModal = false" @accepted="confirmBagCheckin" />
        <ConfirmationModal v-if="displayAdministrationPrompt" :actionDescription="'The bag is checked in. Record the patient administrations for this mission now?'" acceptText="Record Administrations" rejectText="Not Now" @close="displayAdministrationPrompt = false" @accepted="startAdministrations" />
    </div>
</template>


<script>

// import Destroy from '@/components/actions/Destroy.vue'
// import Move from '@/components/actions/Move.vue'
// import Receive from '@/components/actions/Receive.vue'
// import Reverse from '@/components/actions/Reverse.vue'
import NewTransferModal from '@/components/modals/NewTransferModal.vue';
import DestructionModal from '@/components/modals/DestructionModal.vue';
import BatchModal from '../modals/BatchModal.vue';
import LostDamagedModal from '@/components/modals/LostDamagedModal.vue';
import AdjustmentModal from '@/components/modals/AdjustmentModal.vue';
import AdministrationModal from '@/components/modals/AdministrationModal.vue';
import TheatreCheckoutModal from '@/components/modals/TheatreCheckoutModal.vue';
import TheatreCheckinModal from '@/components/modals/TheatreCheckinModal.vue';
import ClinicianHoldCheckoutModal from '@/components/modals/ClinicianHoldCheckoutModal.vue';
import ClinicianHoldCheckinModal from '@/components/modals/ClinicianHoldCheckinModal.vue';
import BagCheckinModal from '@/components/modals/BagCheckinModal.vue';
import BagCheckoutModal from '@/components/modals/BagCheckoutModal.vue';
import DeliveryModal from '@/components/modals/DeliveryModal.vue';
import AmbulanceAdministrationModal from '@/components/modals/AmbulanceAdministrationModal.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import NewRequisitionModal from '@/components/modals/NewRequisitionModal.vue';
import ReceivePOMModal from '@/components/modals/ReceivePOMModal.vue';
// import AdministrationModal from '@/components/modals/AdministrationModal.vue';


export default{
    data(){
        return{
            transferType: '',
            displayForm:'',
            view:'',
            displayConfirmModal: false,
            pendingForm: '',
            pendingType: '',
            // Offered once a bag is back: the administrations given on the mission are recorded after
            // the check in, and the check in row is what they are recorded against.
            displayAdministrationPrompt: false,
            administrationContext: null,
        }
    },
    components:{
        NewTransferModal,
        DestructionModal,
        LostDamagedModal,
        AdjustmentModal,
        AdministrationModal,
        TheatreCheckoutModal,
        TheatreCheckinModal,
        ClinicianHoldCheckoutModal,
        ClinicianHoldCheckinModal,
        BagCheckinModal,
        BagCheckoutModal,
        DeliveryModal,
        BatchModal,
        AmbulanceAdministrationModal,
        ConfirmationModal,
        NewRequisitionModal,
        ReceivePOMModal
        // Destroy,
        // Move,
        // Receive,
        // Reverse
    },
    methods:{
        close(value, value2, meta) {
            if (value) {
                // Read before the form is cleared - only a bag check in leads to the prompt below.
                const wasBagCheckin = this.displayForm == 'clinician-hold-checkin';
                this.displayForm = '';

                if (wasBagCheckin && value2 == 'success') {
                    this.administrationContext = meta || null;
                    this.displayAdministrationPrompt = true;
                }

                if (this.$route.name == 'Drug Register' && value2 == 'success') {
                    console.log('loading the drug register stuff');
                    this.$store.dispatch('getDrugRegister', {
                        sort_direction: 'desc',
                        col: 'created_at',
                        page: 1,
                        filters: {
                            transaction_id: '',
                            to_from: '',
                            entered_by: '',
                            date: {
                                start: '',
                                end: ''
                            },
                            drug: '',
                            imprest_only: false
                        }
                    });
                }
            }
        },
        action(form, type){
            if ((form === 'bag-checkin' || form === 'clinician-hold-checkin') && this.$store.state.currentLocation && this.$store.state.currentLocation.type === 'bag') {
                this.pendingForm = form;
                this.pendingType = type;
                this.displayConfirmModal = true;
                return;
            }

            this.executeAction(form, type);
        },
        confirmBagCheckin() {
            this.displayConfirmModal = false;
            this.executeAction(this.pendingForm, this.pendingType);
        },
        startAdministrations() {
            this.displayAdministrationPrompt = false;
            this.displayForm = 'ambulance-administration';
        },
        executeAction(form, type) {
            // Opened from the menu rather than off the back of a check in, so there is no bag to
            // record against. Left set, the next administration would attach to an old check in.
            this.administrationContext = null;
            console.log('this is the selected form to display', form, localStorage.getItem('user_id'));
            this.displayForm = form;
            this.transferType = type;
        }
    },
    computed: {
        cartonCloudRestriction() {
            // this is a special carton cloud integration restriction for warehouse
            // that restricts manual new purchase or sales
            // orders creation as per DNH requirements
            // to limit creation of extraneous invoices
            if (this.$store.state.user.integration_type === 'carton-cloud') {
                return (this.$store.state.user.integration_type === 'carton-cloud' && this.$store.state.user.role.permissions.includes('can_do_admin_roles'));
            } else {
                return (this.$store.state.company.type === 'warehouse');
            }
        }
    },
    mounted(){
        console.log('this is the window view', window.location.pathname);
        this.view = window.location.pathname.slice(1);
    }
}

</script>